<template>
  <div>
    <data-table ref="dataTable" :option="option" class="tablebe">
      <template slot="headAction">
        <a-button type="primary" @click="mergeHistory">合并档案</a-button>
      </template>
      <template slot="rowAction" slot-scope="text, record">
        <a-button type="link" size="small" @click="checkDetail(record)"
          >详情</a-button
        >
        <a-divider type="vertical" />
        <a-button type="link" size="small" @click="editDetail(record)"
          >编辑</a-button
        >
        <a-divider type="vertical" v-if="record.GuestHistoryType == 0" />
        <a-popconfirm
          title="是否把此客人转为会员?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="convertToMember(record)"
        >
          <a-button v-if="record.GuestHistoryType == 0" type="link" size="small"
            >转为会员</a-button
          >
        </a-popconfirm>

        <a-divider type="vertical" v-if="record.GuestHistoryType != 2" />
        <a-button
          type="link"
          v-if="record.GuestHistoryType != 2"
          size="small"
          @click="AddToBlackList(record)"
          >加入黑名单</a-button
        >
      </template>
    </data-table>
    <GuestDetail ref="GuestDetail"></GuestDetail>
    <a-modal
      centered
      title="加入黑名单"
      v-model="visible"
      okText="确认"
      @cancel="visible = false"
      @ok="submitAddToBlackList"
      :maskClosable="false"
      :destroyOnClose="true"
      :confirmLoading="confirmLoading"
    >
      <div style="margin:20px 0">
        <span style="float:left;padding:0 10px;">原因:</span>
        <a-textarea style="width:80%" v-model="Remark" rows="2"></a-textarea>
      </div>
    </a-modal>
    <Edit ref="Edit" @submit="updateGrid"></Edit>
    <MergeGuestHistory
      ref="MergeGuestHistory"
      @update="editMergeData"
    ></MergeGuestHistory>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import GuestDetail from "./GuestDetail";
import MergeGuestHistory from "./MergeGuestHistory";
// import { cache } from "@/utils/common";
// import cloneDeep from "lodash/cloneDeep";
import Edit from "@/views/member/manage/Edit";
import moment from "moment";
moment.locale("zh-cn");
export default {
  name: "GuestList",
  components: {
    DataTable,
    GuestDetail,
    MergeGuestHistory,
    Edit
  },
  data() {
    return {
      option: {},
      visible: false,
      confirmLoading: false,
      Remark: "",
      currentItem: {},
      mergeData: {},
      isMergeData: false,
      mergeIds: [],
      submitApi: ""
    };
  },
  created() {
    this.option = {
      headSearch: {
        width: 1000,
        colnum: 4,
        content: [
          {
            label: "类型",
            type: "select",
            name: "GuestHistoryType",
            api: "Common_GetSelect",
            param: {
              Types: "GuestHistoryType"
            },
            dataField: "Data.GuestHistoryType"
          },
          {
            label: "消费总额大于",
            name: "totalPrice",
            labelCol: 6,
            type: "number"
          },
          {
            label: "住店次数大于",
            name: "checkInNum",
            type: "number"
          },
          {
            label: "关键字",
            name: "Keyword",
            props: {
              placeholder: "姓名/联系方式"
            }
          }
        ],
        onSubmitBefore: values => {
          return values;
        }
      },
      form: {
        title: "客户",
        width: 980,
        selectCodes: [
          { name: "Type", code: "GuestHistoryType" },
          { name: "IdType", code: "IdType" }
        ],
        content: [
          {
            label: "姓名",
            placeholder: "请输入姓名",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请输入姓名!" }]
            }
          },
          {
            label: "联系方式",
            name: "Phone"
          },
          {
            label: "性别",
            type: "radio-group",
            name: "Sex",
            data: [
              {
                value: "男",
                label: "男"
              },
              {
                value: "女",
                label: "女"
              }
            ]
          },
          {
            label: "类型",
            type: "select",
            name: "Type"
          },
          {
            label: "证件类型",
            type: "select",
            name: "IdType"
          },
          {
            label: "证件号码",
            placeholder: "请输入证件号码",
            name: "IdNumber",
            onChange: e => {
              var value = e.target.value;
              var res = this.$common.IdentityCodeValid(value);
              if (res) {
                const formData = this.$refs.dataTable.getFormData(true);
                this.$refs.dataTable.setFormData({
                  ...formData,
                  Birthday: res[1]
                });
              }
            }
          },
          {
            label: "生日",
            name: "Birthday",
            type: "date",
            props: {
              placeholder: "请输入生日",
              disabledDate: current => {
                return current && current > moment().endOf("day");
              }
            }
          },
          {
            label: "国籍",
            placeholder: "请输入国籍",
            name: "Country"
          },
          {
            label: "喜好",
            name: "Like",
            type: "textarea",
            colnum: 2,
            props: {
              rows: 2
            }
          },
          {
            label: "备注",
            type: "textarea",
            name: "Remark",
            colnum: 2,
            props: {
              rows: 2
            }
          }
        ],

        edit: {
          // submitApi: this.submitApi,
          onOpenAfter: res => {
            if (this.isMergeData) {
              this.mergeData.Type = String(this.mergeData.GuestHistoryType);
              this.option.form.edit.submitApi = "Guest_Merge";
              return this.mergeData;
            } else {
              this.option.form.edit.submitApi = "Guest_UpdateHistory";
              res.Type = String(res.GuestHistoryType);
              return res;
            }
          },
          onSubmitBefore: values => {
            if (this.isMergeData) {
              values.Ids = this.mergeIds;
            }
            if (
              (values.IdType && !values.IdNumber) ||
              (!values.IdType && values.IdNumber)
            ) {
              this.$message.error("证件类型和证件号必须都填写,或者都不填写");
              return false;
            }
            return values;
          },
          onSubmitAfter: () => {
            this.isMergeData = false;
            this.$refs.MergeGuestHistory.onCancel();
          }
        }
      },
      grid: {
        api: "Guest_List",
        columns: [
          {
            title: "序号",
            width: "4%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "姓名",
            width: "10%",
            dataIndex: "Name"
          },
          {
            title: "性别",
            width: "7%",
            dataIndex: "Sex"
          },
          {
            title: "联系方式",
            width: "8%",
            dataIndex: "Phone"
          },
          {
            title: "类型",
            width: "7%",
            dataIndex: "TypeName"
          },
          {
            title: "住店次数",
            width: "7%",
            dataIndex: "CheckInNum"
          },
          {
            title: "总消费",
            align: "right",
            width: "7%",
            dataIndex: "TotalPrice"
          },
          {
            title: "房费消费",
            align: "right",
            width: "7%",
            dataIndex: "RoomPrice"
          },
          {
            title: "其他消费",
            width: "7%",
            align: "right",
            dataIndex: "OtherPrice"
          },
          {
            title: "备注",
            dataIndex: "Remark"
          },
          {
            title: "操作",
            width: "25%",
            dataIndex: "Action",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    checkDetail(record) {
      this.$refs.GuestDetail.show(record);
    },
    convertToMember(record) {
      const baseData = {
        Phone: record.Phone,
        Name: record.Name,
        Sex: record.Sex == "女" ? "1" : "0"
      };
      const otherData = {
        IDType: record.IdType,
        IDNo: record.IdNumber,
        Country: record.Country,
        BirthDate: record.Birthday
      };
      this.$refs.Edit.show(4, "0", baseData, otherData, record.Id);
    },
    //加入黑名单
    AddToBlackList(record) {
      this.visible = true;
      this.Remark = "";
      this.currentItem = record;
    },
    submitAddToBlackList() {
      this.confirmLoading = true;
      this.$post("Guest_AddBlacklist", {
        Id: this.currentItem.Id,
        Remark: this.Remark,
        Type: 2
      })
        .then(() => {
          this.confirmLoading = false;
          this.$message.success("操作成功");
          this.visible = false;
          this.$refs.dataTable.headSearch();
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    editDetail(record) {
      this.$refs.dataTable.edit(record.Id);
    },
    updateGrid() {
      this.$refs.dataTable.headSearch();
    },
    mergeHistory() {
      this.$refs.MergeGuestHistory.show();
    },
    editMergeData(data, ids) {
      this.mergeData = data;
      this.mergeIds = ids;
      this.isMergeData = true;
      this.$refs.dataTable.edit(data.Id);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.data-table .head .head-search-box .ant-form-item-label {
  width: 105px;
}
</style>
